import axios from 'axios'
const axiosInstance = axios.create({
    // withCredentials: true,
    baseURL: "https://" + process.env.VUE_APP_API_HOST
})
export default {
    install: (app) => {
        app.config.globalProperties.$axios={ ...axiosInstance }
    }
}